<template>
    
    <p>
      <input  type="button" @click="checkForm()" value="Submit" >
    </p>
</template>
<script>
import axios from 'axios'
import store from '../store';
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: 'MessageTrigger',
  components:{

  },data(){
    return{}
  }
  ,  mounted(){
      
  } , methods: {
       ...mapActions([
        "TriggerTrMsg",
    ]),
    checkForm: function (e) {
      alert();
        var xmlBodyStr = '';
       // xmlBodyStr +='<?xml version="1.0" encoding="UTF-8"?>';
       // xmlBodyStr +=''
        xmlBodyStr +='<MESGEPF>';
        xmlBodyStr +='<HEADER>';
        xmlBodyStr +='<MSGTYPE>TR</MSGTYPE>';
        xmlBodyStr +='<SCHEME>EMIS</SCHEME>';
        xmlBodyStr +='<TOKEN>5c6ece4f-9da1-4efd-a156-6402f843263e</TOKEN>';
        xmlBodyStr +='<REFID>MIS201810180000000011</REFID>';
        xmlBodyStr +='<LANGUAGEFLAG>EN</LANGUAGEFLAG>';
        xmlBodyStr +='<TRXNDATETIME>2013-10-02 17:59:42</TRXNDATETIME>';
        xmlBodyStr +='<CHANNELCODE>IUTA00000001</CHANNELCODE>';
        xmlBodyStr +='<ENCRYPTVALUE>32811FA0A7B064875DC3066F451E2312FCBB27DBD15D23FBD396B92F0C1CF6B18D13A82DF7A85AA207305564D097C028C5EFF0F5915C93D6ED1ACB935A3BCABB646C87D21EF5880F0A5BB4E559664351A81BE568862793D7F00109948431818B65C32226F99AA933B1B870AF533650624870FB01BF98931240AC2EA55670EC0468C12A43373F5013EE4E2320E89A8482F57B83E884496FA211CC0011868EE9C86E922E6DDC2B820D0C5FD45A6A9D54EA30E20293D308722E3DE6F876D0AAB1C957B4CC273BF0852C9E056B3014CCE920A6EF89922B528820B8A63B211D73488C19C35EB7DEC6653B7CE8251FB71315EDFBCA319679ECA86A3942389DCFAC2406</ENCRYPTVALUE>';
        xmlBodyStr +='</HEADER>';
        xmlBodyStr +='<BODY>';
        xmlBodyStr +='<TR>';
        xmlBodyStr +='<CORRADDRESS1><![CDATA[Jalan 1,127A]]></CORRADDRESS1>';
        xmlBodyStr +='<CORRADDRESS2><![CDATA[Taman Bunga Raya]]></CORRADDRESS2>';
        xmlBodyStr +='<CORRADDRESS3><![CDATA[Kwasan Perindustrian Taman Jaya]]></CORRADDRESS3>';
        xmlBodyStr +='<CORRADDRESS4><![CDATA[Petaling Jaya]]></CORRADDRESS4>';
        xmlBodyStr +='<CORRADDRESS5><![CDATA[Selangor]]></CORRADDRESS5>';
        xmlBodyStr +='<CORRCITY><![CDATA[PETALING JAYA]]></CORRCITY>';
        xmlBodyStr +='<CORRPOSTCODE>46400</CORRPOSTCODE>';
        xmlBodyStr +='<CORRSTATE>10</CORRSTATE>';
        xmlBodyStr +='<CORRCOUNTRY>MAL</CORRCOUNTRY>';
        xmlBodyStr +='<CORRMOBILENO>0126754550</CORRMOBILENO>';
        xmlBodyStr +='<CORRHOUSENO>0379845678</CORRHOUSENO>';
        xmlBodyStr +='<CORROFFICENO>0379845800</CORROFFICENO>';
        xmlBodyStr +='<CORREMAIL><![CDATA[test@mail.com]]></CORREMAIL>';
        xmlBodyStr +='<WDWAMOUNT>130000.45</WDWAMOUNT>';
        xmlBodyStr +='<THIRDPARTIES>';
        xmlBodyStr +='<THIRDPARTY>';
        xmlBodyStr +='<CODE>IPD01</CODE>';
        xmlBodyStr +='<REFNO><![CDATA[IPD010000000001]]></REFNO>';
        xmlBodyStr +='<ACCNO><![CDATA[A123172-1]]></ACCNO>';
        xmlBodyStr +='<PRODUCTS>';
        xmlBodyStr +='<PRODUCT>';
        xmlBodyStr +='<CODE>IPD00001</CODE>';
        xmlBodyStr +='</PRODUCT>';
        xmlBodyStr +='</PRODUCTS>';
        xmlBodyStr +='</THIRDPARTY>';
        xmlBodyStr +='</THIRDPARTIES>';
        xmlBodyStr +='<RESERVE1/>';
        xmlBodyStr +='<RESERVE2/>';
        xmlBodyStr +='<RESERVE3/>';
        xmlBodyStr +='</TR>';
        xmlBodyStr +='</BODY>';
        xmlBodyStr +='<FOOTER>';
        xmlBodyStr +='<AMENDMENTURL><![CDATA[https://ipd.com.my/eng/fundpurchase/form=44223sdcsac=]]></AMENDMENTURL>';
        xmlBodyStr +='<COMPLETIONURL><![CDATA[https://ipd.com.my/eng/fundpurchase/receipt=000002323]]></COMPLETIONURL>';
        xmlBodyStr +='</FOOTER>';
        xmlBodyStr +='</MESGEPF>';
      
      /*  this.axios.post('https://cors-anywhere.herokuapp.com/http://192.168.11.246:8000/TR.aspx', xmlBodyStr)
        .then(res => alert(res.data)) // assuming your response payload is in a data object
    */
//const concat = require('concat-stream')
  
var FormData = require('form-data');
var request = require('request');
 
var form = new FormData();
 
 form.submit('http://192.168.11.246:8000/TR.aspx', function(err, res) {
  // res – response object (http.IncomingMessage)  //
  alert(res)
  alert(err)
  res.resume();
});



    /*var FormData = require('form-data');
    var fs = require('fs');

    var form = new FormData();
    form.append( 'MSGEPF=', xmlBodyStr );
    
    form.submit( 'http://192.168.11.246:8000/TR.aspx', function(err, res) {
      alert(res)
      alert(err)
      res.resume();
    } );
e.preventDefault();
    axios({
        url: 'http://192.168.11.246:8000/TR.aspx?',
        method: 'POST',
        data: xmlBodyStr,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
          //'Content-Type': 'multipart/form-data' 
          }
      }) .then(function (response) {
               console.log(response.data)
               alert(response.data)
                
            })
            .catch(function (response) {
                console.log(response);
               alert(response)
            });
      axios.post('http://192.168.11.246:8000/TR.aspx', xmlBodyStr,{
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
          //'Content-Type': 'multipart/form-data' 
          }
      }).then(function (response) {
        alert(response)
          currentObj.output = response.data;
      })
      .catch(function (error) {
        alert(error)
          currentObj.output = error;
      });*/
    // this.TriggerTrMsg();
    },
      TriggerMsg:function(){
          this.$refs.form.submit()
          
      },
       processSignupForm(e) {
           
 // e.preventDefault();

  // form processing here
}
  }
}
</script>